<script setup>
  const { event } = defineProps(['event']);
</script>

<!----------------------------------------------------------------------------->

<template>
  <UpcomingEventCard :event="event" >
    <h2>
      <FightTitleCombo small center>
        <template v-slot:whiteCorner>{{ event.white_corner?.last_name ?? 'TBD' }}</template>
        <template v-slot:blackCorner>{{ event.black_corner?.last_name ?? 'TBD' }}</template>
      </FightTitleCombo>
    </h2>
  </UpcomingEventCard>
</template>

<!----------------------------------------------------------------------------->

<style lang="scss" scoped>
  h2 {
    width: 100%;
    margin-top: px(20);
  }
</style>
